import create from 'zustand';

import { AudioObject } from 'hooks/useElevenLabsAudio';

export type VoiceOver = Array<AudioObject>;

interface VoiceOverState {
  time: number;
  setTime: (index: number) => void;
}

const useVoTextAnimation = create<VoiceOverState>(set => ({
  time: 0,
  setTime: (index: number) => set({ time: index }),
}));

export default useVoTextAnimation;
